import { Reducer, AnyAction, Action } from 'redux';
import { ExperienceTransferListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteExperienceTransfer, ReceiveDeleteExperienceTransfer, FailDeleteExperienceTransfer
} from './action-types';

export const INITIAL_STATE: ExperienceTransferListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined,
  deletingExperienceTransfer: []
};

const reducers: { [indexer: string]: Reducer<ExperienceTransferListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: ExperienceTransferListState, action: ClearList): ExperienceTransferListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined,
      deletingExperienceTransfer: []
    };
  },

  [ACTION.REQUEST_LIST]: (state: ExperienceTransferListState, action: RequestList): ExperienceTransferListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        listItems: undefined,
        deletingExperienceTransfer: []
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: ExperienceTransferListState, action: ReceiveList): ExperienceTransferListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: ExperienceTransferListState, action: FailList): ExperienceTransferListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.REQUEST_DELETE]: (state: ExperienceTransferListState,
    action: RequestDeleteExperienceTransfer): ExperienceTransferListState => {

    return !state.deletingExperienceTransfer || !state.deletingExperienceTransfer.includes(action.id)
      ? {
        ...state,
        deletingExperienceTransfer: [
          ...(state.deletingExperienceTransfer || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE]: (state: ExperienceTransferListState,
    action: ReceiveDeleteExperienceTransfer): ExperienceTransferListState => {

    if (!state.deletingExperienceTransfer || !state.deletingExperienceTransfer.includes(action.id) || !state.listItems?.length) {
      return state;
    }

    const listItems = (state.listItems || []).filter(item => item.id !== action.id);

    return {
      ...state,
      listItems,
      numberOfResults: state.numberOfResults - (state.listItems.length - listItems.length),
      deletingExperienceTransfer: state.deletingExperienceTransfer.filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_DELETE]: (state: ExperienceTransferListState,
    action: FailDeleteExperienceTransfer): ExperienceTransferListState => {

    return state.deletingExperienceTransfer && state.deletingExperienceTransfer.includes(action.id)
      ? {
        ...state,
        deletingExperienceTransfer: state.deletingExperienceTransfer.filter(id => id !== action.id)
      }
      : state;
  }
};

export const reducer: Reducer<ExperienceTransferListState> = (
  state: ExperienceTransferListState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
